function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "zoom-a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57A3FF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3B80FB",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.028 0h13.944c11.192 0 15.469 1.208 19.71 3.477 4.243 2.269 7.572 5.598 9.841 9.84C78.792 17.56 80 21.836 80 33.027v13.945c0 11.192-1.208 15.469-3.477 19.71-2.269 4.243-5.598 7.572-9.84 9.841C62.44 78.792 58.164 80 46.973 80H33.027c-11.192 0-15.469-1.208-19.71-3.477-4.243-2.269-7.572-5.598-9.841-9.84C1.208 62.44 0 58.164 0 46.973V33.027c0-11.192 1.208-15.469 3.477-19.71 2.269-4.243 5.598-7.572 9.84-9.841C17.56 1.208 21.836 0 33.027 0z",
  fill: "url(#zoom-a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.458 26.032c3.891 0 5.34.412 6.788 1.187a8.077 8.077 0 013.36 3.36c.775 1.449 1.188 2.897 1.188 6.789V49.58c0 1.415-.148 1.928-.424 2.446a2.885 2.885 0 01-1.2 1.2c-.518.276-1.03.424-2.446.424H26.892c-3.892 0-5.34-.413-6.79-1.187a8.077 8.077 0 01-3.36-3.36c-.774-1.45-1.186-2.898-1.186-6.79V30.102c0-1.415.147-1.928.424-2.445a2.885 2.885 0 011.2-1.2c.517-.277 1.03-.424 2.445-.424h19.833zm24.61 1.06c.245.333.376.732.376 1.141V50.75c0 1.052-.852 2.094-1.904 2.327-.41.091-.808.043-1.137-.137l-7.936-6.83c-.484-.335-.769-.938-.769-1.623v-9.54c0-.684.285-1.344.769-1.776l7.936-6.518c.845-.629 2.038-.422 2.665.44z",
  fill: "#FFF"
}));

var SvgZoomIco = function SvgZoomIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom_ico.3f44583e.svg";
export { ForwardRef as ReactComponent };